export enum AutoLoginAction {
  None = 0,
  SwitchToTenant = 10,
  SwitchToLandlord = 11,
  SwitchToPurchaser = 12,
  SwitchesList = 13,
  SupportCasesList = 14,
  CreateSupportCase = 15,
  AIImageEnhancement = 16,
  AIPropertyListing = 17,
}
